<app-ngx-mat-table
  tableName="Images"
  [description]="description"
  dataType="image"
  sortActive="id"
  [tableData]="tableData"
  [showActions]="showActions"
  (clickedButton)="clickedButton($event)"
  i18n-tableName
></app-ngx-mat-table>
<router-outlet></router-outlet>
